export default __webpack_public_path__ + "static/media/Antarctica.540fddd3.svg";